import classNames from "./pdf.module.scss";

interface PDFTitlePageProps {
  title: string;
}

const PDFTitlePage = (props: PDFTitlePageProps) => {
  return (
    <div className={"border-dark " + classNames.titlePage}>
      <h1 className={classNames.titlePageHeader}>{props.title}</h1>
    </div>
  );
};

export default PDFTitlePage;
